import React from "react";
import { Button } from "@mui/material";
import { useDispatch } from "react-redux";
import {
  removeCartItem,
  updateCartItem,
} from "../../../Redux/Customers/Cart/Action";
import { IconButton } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { getCart } from "../../../Redux/Customers/Cart/Action";

const CartItem = ({ item, showButton, showError }) => {
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");


  const handleRemoveItemFromCart = async () => {
    const data = { cartItemId: item?._id, jwt };
    await dispatch(removeCartItem(data));
    await dispatch(getCart(jwt));
  };
  const handleUpdateCartItem = async (num) => {
    if (num == 1 && item?.product?.isSizesAvailable) {
      if (
        item?.product?.sizes?.find((prodSize) => prodSize?.name == item?.size)
          ?.quantity == item.quantity
      ) {
        showError("Quantity Not Available!");
        return;
      }
    } else if (!item?.product?.isSizesAvailable) {
      if (num == 1 && item.quantity == item?.product?.quantity) {
        showError("Quantity Not Available!");
        return;
      }
    }
    const data = {
      data: { quantity: item.quantity + num },
      cartItemId: item?._id,
      jwt,
    };
    await dispatch(updateCartItem(data));
    await dispatch(getCart(jwt));
  };

  // useEffect(() => {
  //   if (cart) {
  //     dispatch(getCart(jwt));
  //   }
  // }, [cart]);

  return (
    <div className="p-5 shadow-sm border rounded-sm">
      <div className="flex items-center">
        <div className="w-[5rem] h-[5rem] lg:w-[9rem] lg:h-[9rem] ">
          <img
            className="w-full h-full object-cover object-top"
            src={`${item?.product?.images[0]}`}
            alt=""
          />
        </div>
        {/* opacity-70 */}
        <div className="ml-5 space-y-1">
          <p className="font-semibold text-[#B28585]">{item?.product?.title}</p>
          <p className="text-[#B28585]">
            <b>Size:</b> {item?.size ? item?.size : "Free Size"}, <b>Color:</b>
            {item?.product?.color}
          </p>
          {!showButton && (
            <p>
              <b>Qty:</b> {item.quantity}
            </p>
          )}
          <p className="mt-2 text-[#B28585]">
            <b>Brand:</b> {item?.product?.brand}
          </p>
          <div className="flex items-center mt-3">
            <p className="font-semibold text-lg mr-3">
              ₹{item?.product?.discountedPrice}
            </p>
            <p className="opacity-50 line-through">₹{item?.product?.price}</p>
            <p className="font-semibold ml-0 text-red-500">
              ({item?.product?.discountPercent}% off)
            </p>
          </div>
        </div>
      </div>
      {showButton && (
        <div className="flex items-center lg:space-x-10 pt-4">
          <div className="flex items-center space-x-2 ">
            <IconButton
              onClick={() => handleUpdateCartItem(-1)}
              disabled={item?.quantity <= 1}
              // color="primary"
              aria-label="add an alarm"
              sx={{
                color: "#b28585",
              }}
            >
              <RemoveCircleOutlineIcon />
            </IconButton>

            <span className="py-1 px-7 border rounded-sm">
              {item?.quantity}
            </span>
            <IconButton
              onClick={() => handleUpdateCartItem(1)}
              // color="primary"
              aria-label="add an alarm"
              sx={{
                color: "#b28585",
              }}
            >
              <AddCircleOutlineIcon />
            </IconButton>
          </div>
          <div className="flex text-sm lg:text-base lg:mt-0">
            <Button
              onClick={handleRemoveItemFromCart}
              variant="text"
              sx={{
                color: "#b28585",
              }}
            >
              Remove
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartItem;
